// src/pages/Relatorios.js
import TabelaMargemCritica from '../components/relatorios/TabelaMargemCritica';
import TabelaTopOS from '../components/relatorios/TabelaTopOS';
import React, { useEffect, useState } from 'react';
import DashboardExecutivo from '../components/relatorios/DashboardExecutivo';
import GraficoMetaVsRealizado from '../components/relatorios/GraficoMetaVsRealizado';
import GraficoFunil from '../components/relatorios/GraficoFunil';
import GraficoPizza from '../components/relatorios/GraficoPizza';
import GraficoBarras from '../components/relatorios/GraficoBarras';
import TabelaPerformance from '../components/relatorios/TabelaPerformance';
import { TabelaExecucao, TabelaVendas, TabelaConsolidado, TabelaPagamentos } from '../components/relatorios/TabelaPerformanceComissao';
import FiltrosRelatorios from '../components/relatorios/FiltrosRelatorios';
import CardReceitaCustos from '../components/relatorios/CardReceitaCustos';
import CardReceitasOrigemCanal from '../components/relatorios/CardReceitasOrigemCanal';
import '../styles/Relatorios.css';
import { relatoriosAPI } from '../services/api';

function Relatorios() {
  const getMesAtual = () => {
    const hoje = new Date();
    const ano = hoje.getFullYear();
    const mes = String(hoje.getMonth() + 1).padStart(2, '0');
    return `${ano}-${mes}`;
  };

  const [loading, setLoading] = useState(true);
  const [filtros, setFiltros] = useState({ mes_ano: getMesAtual() });
  
  // 🆕 ESTADO DO CANAL SELECIONADO
  const [canalSelecionado, setCanalSelecionado] = useState('geral');
  
  const [dashboardData, setDashboardData] = useState(null);
  const [metaVsRealizado, setMetaVsRealizado] = useState(null);
  const [funilConversao, setFunilConversao] = useState([]);
  const [topServicos, setTopServicos] = useState([]);
  const [receitaCustos, setReceitaCustos] = useState(null);
  const [receitasOrigem, setReceitasOrigem] = useState(null);
  const [performanceTecnicos, setPerformanceTecnicos] = useState([]);
  const [perfExecucao, setPerfExecucao] = useState({ data: [], totais: null });
  const [perfVendas, setPerfVendas] = useState({ data: [], totais: null });
  const [perfConsolidado, setPerfConsolidado] = useState(null);
  const [topOSLucro, setTopOSLucro] = useState([]);
  const [topOSMargemCritica, setTopOSMargemCritica] = useState([]);

  // 🆕 RECARREGA QUANDO TROCAR DE CANAL
  useEffect(() => {
    carregarDados();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtros, canalSelecionado]);

  const carregarDados = async () => {
    try {
      setLoading(true);
      
      // 🆕 ADICIONA CANAL NOS FILTROS
      const filtrosComCanal = { 
        ...filtros, 
        canal: canalSelecionado 
      };
      
      const [
        dashboardRes,
        metaVsRealizadoRes,
        funilRes,
        servicosRes,
        receitaRes,
        receitasOrigemRes,
        performanceRes,
        topOSRes,
        margemCriticaRes,
        perfExecRes,
        perfVendRes,
        perfConsRes
      ] = await Promise.all([
        relatoriosAPI.dashboardExecutivo(filtrosComCanal),
        relatoriosAPI.metaVsRealizado(),
        relatoriosAPI.funilConversao(filtrosComCanal),
        relatoriosAPI.topServicos({ ...filtrosComCanal, limit: 5 }),
        relatoriosAPI.receitaCustos(filtrosComCanal),
        relatoriosAPI.receitasOrigemCanal(filtrosComCanal),
        relatoriosAPI.performanceTecnicos(filtrosComCanal),
        relatoriosAPI.topOSLucro(filtrosComCanal),
        relatoriosAPI.topOSMargemCritica(filtrosComCanal),
        relatoriosAPI.performanceExecucao(filtrosComCanal),
        relatoriosAPI.performanceVendas(filtrosComCanal),
        relatoriosAPI.performanceConsolidado(filtrosComCanal)
      ]);

      // Passa os dados como vieram do backend (SEM modificar)
      setDashboardData(dashboardRes?.data?.data ?? null);
      setMetaVsRealizado(metaVsRealizadoRes?.data?.data ?? null);
      setFunilConversao(funilRes?.data?.data ?? []);
      setTopServicos(servicosRes?.data?.data ?? []);
      setTopOSLucro(topOSRes?.data?.data ?? []);
      setReceitaCustos(receitaRes?.data?.data ?? null);
      setReceitasOrigem(receitasOrigemRes?.data?.data ?? null);
      setPerformanceTecnicos(performanceRes?.data?.data ?? []);
      setTopOSMargemCritica(margemCriticaRes?.data?.data ?? []);
      setPerfExecucao({ data: perfExecRes?.data?.data ?? [], totais: perfExecRes?.data?.totais ?? null });
      setPerfVendas({ data: perfVendRes?.data?.data ?? [], totais: perfVendRes?.data?.totais ?? null });
      setPerfConsolidado(perfConsRes?.data ?? null);
    } catch (error) {
      console.error('❌ Erro ao carregar relatórios:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleFiltrar = (novosFiltros) => setFiltros(novosFiltros);

  // 🆕 FUNÇÃO PARA TROCAR CANAL
  const handleTrocarCanal = (canal) => {
    setCanalSelecionado(canal);
  };

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner"></div>
        <p>Carregando relatórios...</p>
      </div>
    );
  }

  return (
    <div className="relatorios-page">
      <div className="relatorios-header">
        <div className="relatorios-title">
          <h1>📊 Relatórios Gerenciais</h1>
          <p>Análise completa de performance e resultados</p>
        </div>
      </div>

      <FiltrosRelatorios filtros={filtros} onFiltrar={handleFiltrar} />

      {/* 🆕 SELETOR DE CANAIS */}
      <div className="canal-selector">
        <button
          className={`canal-btn ${canalSelecionado === 'geral' ? 'active' : ''}`}
          onClick={() => handleTrocarCanal('geral')}
        >
          <span className="canal-icon">🌐</span>
          <span className="canal-label">GERAL</span>
        </button>
        
        <button
          className={`canal-btn ${canalSelecionado === 'presencial' ? 'active' : ''}`}
          onClick={() => handleTrocarCanal('presencial')}
        >
          <span className="canal-icon">🔧</span>
          <span className="canal-label">PRESENCIAL</span>
        </button>
        
        <button
          className={`canal-btn ${canalSelecionado === 'licitacao' ? 'active' : ''}`}
          onClick={() => handleTrocarCanal('licitacao')}
        >
          <span className="canal-icon">🏛️</span>
          <span className="canal-label">LICITAÇÕES</span>
        </button>
        
        <button
          className={`canal-btn ${canalSelecionado === 'marketplace' ? 'active' : ''}`}
          onClick={() => handleTrocarCanal('marketplace')}
        >
          <span className="canal-icon">🛒</span>
          <span className="canal-label">MARKETPLACE</span>
        </button>
        
        <button
          className={`canal-btn ${canalSelecionado === 'bni' ? 'active' : ''}`}
          onClick={() => handleTrocarCanal('bni')}
        >
          <span className="canal-icon">🤝</span>
          <span className="canal-label">BNI</span>
        </button>
      </div>

      {dashboardData && (
        <DashboardExecutivo data={dashboardData} canal={canalSelecionado} />
      )}

      <div className="relatorios-grid-2col">
        <div className="relatorios-card">
          <h3 className="relatorios-card-title">🎯 Meta vs Realizado (12 meses)</h3>
          <GraficoMetaVsRealizado data={metaVsRealizado} />
        </div>

        <div className="relatorios-card">
          <h3 className="relatorios-card-title">🔄 Funil de Conversão</h3>
          <GraficoFunil data={funilConversao} />
        </div>
      </div>

      <div className="relatorios-grid-2col">
        <div className="relatorios-card">
          <h3 className="relatorios-card-title">🏆 Top 5 OS com Maior Lucro</h3>
          <TabelaTopOS data={topOSLucro} />
        </div>

        <div className="relatorios-card">
          <h3 className="relatorios-card-title">💰 Receita vs Custos</h3>
          <CardReceitaCustos data={receitaCustos} />
        </div>
      </div>

      <div className="relatorios-grid-2col">
        <div className="relatorios-card">
          <h3 className="relatorios-card-title">📊 Receitas por Origem</h3>
          <CardReceitasOrigemCanal data={receitasOrigem} />
        </div>

        <div className="relatorios-card">
          <h3 className="relatorios-card-title">🏆 Performance por Técnico</h3>
          <TabelaPerformance data={performanceTecnicos} />

        <div className="relatorio-secao">
          <h3 className="secao-titulo">🔧 Performance por Serviço Executado</h3>
          <p style={{fontSize:12,color:'#888',marginBottom:8}}>Comissão de 8% sobre lucro líquido (OS faturadas)</p>
          <TabelaExecucao data={perfExecucao.data} totais={perfExecucao.totais} />
        </div>

        <div className="relatorio-secao">
          <h3 className="secao-titulo">💼 Performance de Venda de Produtos</h3>
          <p style={{fontSize:12,color:'#888',marginBottom:8}}>Comissão de 5% sobre lucro líquido (OS faturadas)</p>
          <TabelaVendas data={perfVendas.data} totais={perfVendas.totais} />
        </div>

        <div className="relatorio-secao">
          <h3 className="secao-titulo">📊 Performance Consolidada</h3>
          <p style={{fontSize:12,color:'#888',marginBottom:8}}>Visão unificada — técnicos e vendedores</p>
          <TabelaConsolidado execucao={perfConsolidado?.execucao} vendas={perfConsolidado?.vendas} totais={perfConsolidado?.totais} />
          <TabelaPagamentos pagamentos={perfConsolidado?.pagamentos} />
        </div>
        </div>
      </div>

      <div className="relatorios-card-full">
        <h3 className="relatorios-card-title">⚠️ OS com Margem Crítica</h3>
        <TabelaMargemCritica data={topOSMargemCritica} />
      </div>
    </div>
  );
}

export default Relatorios;